<template>
  <message-template :direction="'incoming'" :time="time" :image="image">
    <div class="log-send-location-block">
      <span class="red-marker">
        <i class="fas fa-map-marker-alt"></i>
      </span>
      <span v-if="data.locationAddress">{{data.locationAddress}}</span>
      <span v-if="data.locationTitle || data.locationLatitude || data.locationLongitude">
        {{data.locationTitle || 'Location input'}}
        <br />
        Latitude: {{data.locationLatitude || 'Unknown'}}
        <br />
        Longitude: {{data.locationLongitude || 'Unknown'}}
      </span>
    </div>
  </message-template>
</template>
<script>
import MessageTemplate from './MessageTemplate.vue';

export default {
  name: 'sendLocation',
  components: {
    'message-template': MessageTemplate,
  },
  props: {
    data: {
      type: Object,
    },
    time: {
      type: Number,
      default: 0,
    },
    channel: {
      type: String,
      default: '',
    },
    uid: {
      type: String,
    },
    image: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="scss" scoped>
.log-send-location-block {
  background-color: #efefef;
  padding: 10px;
  display: inline-block;
  text-align: left;
  border-radius: 10px 0 10px 10px;
  .red-marker {
    color: #ff5b58;
  }
}
</style>
